import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router'

import Layout from '@/lib/ui/layout'
import Home from '@/app/home'
import NotFound from '@/app/not-found'
import '@/index.css'

const element = document.querySelector('#app')!
const root = createRoot(element)

root.render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
